    <div class="wrapper">
        <div class="content">
            <div class="user" (click)="select(user.id)" [class.selected]="modalData.isSelected(user.id)" *ngFor="let user of modalData.users">
                <div class="avatar-wrapper">
                        <div  class="avatar-item-outer">
                            <div class="avatar-item-inner" [style.backgroundColor]="user.colour">{{getInitials(user.name)}}</div>
                        </div>
                </div>
                <div class="name">{{user.name}}</div>
            </div>
        </div>
    </div>